import React from "react";
import "./Footer.css";
import logo from "./images/logo2.jpg";
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaPhoneAlt
} from "react-icons/fa";

const Footer = () => {

  return (

    <div className="footer" >

      <div className="container">

        <div className="row">

          {/* LEFT */}
          <div className="col-md-6 footer-left">

            <div className="footer-top">

              <img src={logo} alt="logo" className="footer-logo" />

              <p className="footer-text">
                Our Pest Management services offer eco-friendly solutions
                to protect homes and businesses from pests, ensuring a
                safe, pest-free environment.
              </p>

            </div>

            {/* SOCIAL */}
            <div className="footer-social">

              <a href="https://www.facebook.com/totalpestcontrolpune/" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>

              <a href="https://www.linkedin.com/company/total-pest-control-pest-control-services-in-pune/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>

              <a href="https://www.instagram.com/totalpestcontrolindia?igsh=MWpjN2c3MmxvaTE0Nw%3D%3D" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>

            </div>

          </div>

          {/* RIGHT */}
          <div className="col-md-6 footer-right">
            {/* CENTER */}
            <div className="footer-center">
              {/* PHONE */}
              <div className="footer-contact">
                <FaPhoneAlt />
                <span>
                  +91 9822290400  &nbsp;&nbsp;
                  +91 7666996177
                </span>
              </div>
              {/* EMAIL */}
              <div className="footer-contact">
                <FaEnvelope />
                <span>info@totalpestcontrol.co.in</span>
              </div>

            </div>



            {/* ADDRESS */}
            <div className="footer-address">
              <div className="footer-contact">
                <FaMapMarkerAlt />
                <span>
                  Total Pest Control <br />
                  Lane 3, vishwashanti colony, <br />
                  Pimple Saudagar, Near Cream&nbsp;&amp;&nbsp;Stone <br />
                  Pune - 411027 Maharashtra, INDIA
                </span>
              </div>
            </div>


          </div>

        </div>

      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        <p>
          Total Pest Control Copyright 2026. All Rights Reserved | Developed by{" "}
          <a
            href="https://www.dezykode.com/home"
            target="_blank"
            rel="noopener noreferrer"
          >
            Dezykode IT Solutions
          </a>
        </p>
      </div>

    </div>
  );
};

export default Footer;